import { Typography } from "@material-ui/core";
import { Monitoring } from "app/models/monitoring";
import { Pacient } from "app/models/pacient";
import DynamicDecubitusClockDrawing from "app/modules/Monitoring/detail/views/DynamicDecubitusClockDrawing";
import FixedDecubitusClockDrawing from "app/modules/Monitoring/detail/views/FixedDecubitusClockDrawing";
import React from "react";
import {
  FormattedMessage,
  injectIntl,
  WrappedComponentProps,
} from "react-intl";
import {
  getFixedClockDecubitusPositionForDate,
  getDynamicClockDecubitusPositionForDate,
} from "app/models/position";
import { Spinner } from "react-bootstrap";

interface PatientLPPCardViewProps {
  patient: Pacient;
  monitoring: Monitoring | null;
  loading?: boolean;
}

function PatientLPPCardView({
  patient,
  monitoring,
  loading = false,
}: PatientLPPCardViewProps & WrappedComponentProps) {
  const now = new Date();
  const checkinDate = new Date(monitoring?.checkin ?? 0);

  const clockType =
    monitoring?.pressureInjury?.clockType === "dynamic" ? "Dinâmico" : "Padrão";

  const expectedPosition =
    monitoring?.pressureInjury?.clockType === "dynamic"
      ? getDynamicClockDecubitusPositionForDate(checkinDate, now)
      : getFixedClockDecubitusPositionForDate(now);

  return (
    <div style={{ width: "100%", height: "100%", position: "relative" }}>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            color: "#007896",
          }}
        >
          <Spinner animation="border" />
        </div>
      ) : (
        <>
          <Typography variant="h5" style={{ marginTop: 10, color: "#007896" }}>
            {patient.name}
          </Typography>
          <Typography variant="body1" style={{ color: "#948d8d" }}>
            Lesão por Pressão
          </Typography>
          {monitoring ? (
            !monitoring.pressureInjury ||
            monitoring.pressureInjury?.enabled === "0" ? (
              <Typography variant="body1" style={{ marginTop: 15 }}>
                Este{" "}
                <FormattedMessage id="PATIENTS.NOMENCLATURE.SINGULAR.LOWER_CASE" />{" "}
                está sendo monitorado, mas com a{" "}
                <span style={{ color: "red", fontWeight: 500 }}>
                  Lesão por Pressão desativada
                </span>
                . Vá até o monitoramento completo para ativá-la.
              </Typography>
            ) : (
              <>
                <Typography variant="body1" style={{ marginTop: 15 }}>
                  Última Evolução:{" "}
                  <strong>{monitoring.iniPosition ?? "Sem Registro"}</strong>
                </Typography>
                <Typography
                  variant="body1"
                  style={{
                    color:
                      expectedPosition === monitoring.iniPosition
                        ? "green"
                        : "red",
                  }}
                >
                  Evolução Esperada: <strong>{expectedPosition}</strong>
                </Typography>
                <Typography
                  variant="body1"
                  style={{ marginTop: 15, width: "50%" }}
                >
                  Tipo de Relógio: <strong>{clockType}</strong>
                </Typography>
                <div
                  style={{
                    position: "absolute",
                    bottom: -80,
                    right: -155,
                    transform: "translate(-50%, -50%)",
                    borderRadius: "50%",
                    border: "6px solid #007896",
                    backgroundColor: "#fff",
                    boxShadow: "0 4px 8px rgba(22, 12, 12, 0.2)",
                  }}
                >
                  {monitoring.pressureInjury?.clockType === "fixed" ? (
                    <FixedDecubitusClockDrawing
                      size={170}
                      hasBlinkingBall={false}
                    />
                  ) : (
                    <DynamicDecubitusClockDrawing
                      startMonitoringDate={checkinDate}
                      size={170}
                      hasBlinkingBall={false}
                    />
                  )}
                </div>
              </>
            )
          ) : (
            // Monitoring is not set
            <Typography variant="body1" style={{ marginTop: 15 }}>
              Este{" "}
              <FormattedMessage id="PATIENTS.NOMENCLATURE.SINGULAR.LOWER_CASE" />{" "}
              <span style={{ color: "red", fontWeight: 500 }}>
                não está sendo monitorado
              </span>{" "}
              no momento.
            </Typography>
          )}
        </>
      )}
    </div>
  );
}

export default injectIntl(PatientLPPCardView);
